const memberToRemoveParams = (member: any, inviterEmail: string): any => {
  return {
    context: {
      intent: 'update household member',
      callback: 'http://callback..',
    },
    resource: {
      resourceType: 'Patient',
      identifier: [
        {
          system: 'http://proactivehealthtech.com/sid/d2md/v1/person/username',
          value: inviterEmail,
        },
      ],
    },
    patch: [
      {
        op: 'remove',
        path: '/member',
        value: [
          {
            entity: member?.entity,
          },
        ],
      },
    ],
  };
};

export default memberToRemoveParams;
